import { Icon, Modal } from "@bluframe/blublocks"
import Button from "components/buttons/Button"
import ConfirmModal from "components/ConfirmModal"
import TechSpecsList from "components/TechSpecs/List"
import H4 from "components/Typography/H4"
import H5 from "components/Typography/H5"
import Paragraph from "components/Typography/Paragraph"
import serviceNameLabels from "config/serviceNameLabels"

import { ComponentProps } from "."
import {
  Column,
  Columns,
  ModalWrapper,
  ServiceNameAndAction,
  TechSpecsAvailable,
  TechSpecsAvailableUl,
  Wrapper
} from "./styled"

const Selector = ({
  modal,
  onCancel,
  onConfirm,
  onSelectAllTechSpecs,
  onSelectClick,
  onSelectTechSpec,
  techSpecsAvailable,
  techSpecsSelected
}: ComponentProps) => (
  <>
    <Wrapper aria-label="Tech Specs Selector Controls" role="region">
      <Paragraph>{`Tech Specs Selected: ${techSpecsSelected.length}`}</Paragraph>

      <Button label="Select" onClick={onSelectClick} />
    </Wrapper>

    <Modal {...modal} name="Tech Specs Selector">
      <ConfirmModal
        message={
          <ModalWrapper>
            <H4>{"Select Tech Specs"}</H4>

            <Columns>
              <Column aria-labelledby="availableTechSpecs" role="region">
                <H5 id="availableTechSpecs">{"Available"}</H5>

                <TechSpecsAvailableUl aria-label="Available Tech Specs">
                  {techSpecsAvailable.map((item) => (
                    <li
                      aria-label={`${
                        serviceNameLabels[item.serviceName]
                      } Tech Specs`}
                      key={item.serviceName}
                    >
                      <TechSpecsAvailable>
                        <ServiceNameAndAction>
                          <Paragraph>
                            {serviceNameLabels[item.serviceName]}
                          </Paragraph>

                          <Button
                            icon={<Icon name="IoArrowForward" />}
                            iconOnly
                            label="Select All"
                            onClick={onSelectAllTechSpecs(item.techSpecs)}
                            outlined
                            rounded
                          />
                        </ServiceNameAndAction>

                        <TechSpecsList
                          onAdd={onSelectTechSpec}
                          techSpecs={item.techSpecs}
                        />
                      </TechSpecsAvailable>
                    </li>
                  ))}
                </TechSpecsAvailableUl>
              </Column>

              <Column aria-labelledby="selectedTechSpecs" role="region">
                <ServiceNameAndAction>
                  <H5 id="selectedTechSpecs">{"Selected"}</H5>

                  <Button
                    icon={<Icon name="IoClose" />}
                    iconOnly
                    label="Clear"
                    onClick={onSelectAllTechSpecs([])}
                    outlined
                    rounded
                    secondary
                  />
                </ServiceNameAndAction>

                <TechSpecsList
                  onRemove={onSelectTechSpec}
                  techSpecs={techSpecsSelected}
                />
              </Column>
            </Columns>
          </ModalWrapper>
        }
        onClose={onCancel}
        onConfirm={onConfirm}
      />
    </Modal>
  </>
)

Selector.whyDidYouRender = true
export default Selector
